<template>
  <div class="group-root" :class="{ root }">
    <div class="name" :class="{ root }" @click="toggleOpen">
      <b-form-checkbox v-model="group._selected" :disabled="readOnly"
        @change="updateSiblings($event, group)"
      >
        {{ group.name }}<p class="d-inline small text-muted m-0">({{ group.id }})</p>
      </b-form-checkbox>
      <div class="show-subitems" v-show="group.subGroups && group.subGroups.length" :title="open ? 'Ocultar subgrupos' : 'Ver subgrupos'">
        <i class="fal fa-minus-circle" v-if="open"></i>
        <i class="fal fa-plus-circle" v-else></i>
      </div>
    </div>
    <div class="subgroups" v-show="open && group.subGroups && group.subGroups.length">
      <AdminGroupSelectionTreeItem v-for="item in group.subGroups" :key="item.id" :group="item" :watchActive="watchActive" :readOnly="readOnly"
        @update-group="updateSiblings"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Group } from '@/types/Catalogs'

@Component({
  name: 'AdminGroupSelectionTreeItem'
})
export default class AdminGroupSelectionTreeItem extends Vue {
  @Prop({ required: true })
  group: Group

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: true })
  opened: boolean

  @Prop({ required: false, default: false })
  watchActive: boolean

  @Prop({ required: false, default: false })
  readOnly: boolean

  open = false

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }

  updateSiblings (selected: boolean, group: Group) {
    this.$emit('update-group', selected, group)
  }
}
</script>
